import classNames from 'classnames';
import { Settings } from 'react-slick';

import SlickSlider from '@ui/SlickSlider';
import { useTabletOrWider } from '@utils/mediaQuery';
import { Link } from '@ui/Link';
import { SliderArrowProps, SliderArrow } from '@ui/SliderArrow';

import s from './Banner.sss';

// types
type Image = {
  mobile: string
  tablet: string
};

type Slide = {
  title: string;
  image: Image;
  url: string
};

type BannerProps = {
  slides: Slide[];
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowLeft: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} direction="left" overrideClassName={s.arrowLeft} />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowRight: React.FC<SliderArrowProps> = ({ className, ...props }) => (
  <SliderArrow {...props} overrideClassName={s.arrowRight} />
);

// constants
const sliderSettings: Settings = {
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  centerMode: true,
  dots: true,
  infinite: true,
  initialSlide: 0,
  nextArrow: <ArrowRight />,
  prevArrow: <ArrowLeft />,
  responsive: [{
    breakpoint: 1080,
    settings: {
      arrows: false,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
    },
  }],
  slidesToShow: 1,
  speed: 700,
  variableWidth: true,
};

export const Banner: React.FC<BannerProps> = ({
  slides,
}) => {
  const isTabletOrWider = useTabletOrWider();

  return (
    <div className={s.root}>
      {
        slides.length === 1
          ? (
            <div className={classNames(s.slideItem, s.slideItemSingle)}>
              <a className={s.slideLink} href={slides[0].url}>
                <img
                  className={s.slideImage}
                  src={isTabletOrWider ? slides[0].image.tablet : slides[0].image.mobile}
                  alt={slides[0].title}
                />
              </a>
            </div>
          )
          : (
            <SlickSlider
              {...sliderSettings}
              dotsClass={s.dots}
            >
              {
                slides.map(
                  (slide, i) => (
                    <div
                      key={i}
                      className={s.slideItem}
                    >
                      <Link className={s.slideLink} href={slide.url}>
                        <img
                          className={s.slideImage}
                          src={isTabletOrWider ? slide.image.tablet : slide.image.mobile}
                          alt={slide.title}
                        />
                      </Link>
                    </div>
                  ),
                )
              }
            </SlickSlider>
          )
      }
    </div>
  );
};
